<template>
  <v-row
    v-if="!override"
  >
    <v-col
      :cols="cols"
      class="my-auto"
    >
      {{ Math.round(margin * 100) }}%
      <span v-if="default_margin(categoryId || null, coreProductId || null, materialId || null, quantity || null, optionGroupId || null)">
        (Default)
      </span>
    </v-col>
    <v-col cols="auto">
      <v-icon
        small
        @click="showOverride"
      >
        {{ editIcon }}
      </v-icon>
    </v-col>
  </v-row>
  <v-row
    v-else
    dense
  >
    <v-col
      :cols="cols"
    >
      <v-select
        v-model="overrideMargin"
        :label="label"
        :items="margins"
        outlined
        hide-details="auto"
        color="black"
        class="font-weight-medium"
        dense
        @change="changeMargin"
      />
    </v-col>
    <template v-if="!saveOnBlur">
      <v-col
        :cols="cols"
        class="my-auto"
      >
        <v-btn
          color="green"
          small
          rounded
          elevation="0"
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </v-col>
      <v-col
        :cols="cols"
        class="my-auto"
      >
        <v-btn
          color="error"
          small
          rounded
          elevation="0"
          :loading="saving"
          @click="override = false"
        >
          Cancel
        </v-btn>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiPencil } from '@mdi/js';

export default {
  name: 'MarginOverride',

  props: {
    categoryId: { type: [Number, undefined], default: undefined },
    coreProductId: { type: [Number, undefined], default: undefined },
    materialId: { type: [String, undefined], default: undefined },
    quantity: { type: [Number, undefined], default: undefined },
    optionGroupId: { type: [String, undefined], default: undefined },
    label: { type: [String, undefined], default: undefined },
    saveOnBlur: { type: Boolean, default: false },
    allowAll: { type: Boolean, default: false },
    cols: { type: String, default: 'auto' }
  },

  components: {
  },

  data: () => ({
    overrideMargin: 0,
    override: false,
    saving: false,
    editIcon: mdiPencil
  }),

  computed: {
    margin () {
      return this.base_margin(this.categoryId, this.coreProductId, this.materialId, this.quantity, this.optionGroupId);
    },
    margins () {
      let list = [];
      if (this.allowAll) {
        list = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45];
      }
      list = list.concat([0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2, 2.25, 2.5, 2.75, 3]);
      return list.map(x => ({ value: x, text: `${Math.round(x * 100)}%` }));
    },
    ...mapGetters({
      base_margin: 'admin/productSetup/margin',
      default_margin: 'admin/productSetup/default_margin'
    })
  },

  mounted () {
    if (this.saveOnBlur) {
      this.showOverride();
    }
  },

  methods: {
    showOverride () {
      this.overrideMargin = this.margin;
      this.override = true;
    },
    save () {
      this.saving = true;
      this.$store.dispatch('admin/productSetup/saveMargin', {
        categoryId: this.categoryId,
        coreProductId: this.coreProductId,
        materialId: this.materialId,
        quantity: this.quantity,
        optionGroupId: this.optionGroupId,
        margin: this.overrideMargin
      })
        .then(() => {
          this.$emit('save', this.overrideMargin);
          if (!this.saveOnBlur) {
            this.override = false;
          }
        }).finally(() => {
          this.saving = false;
        });
    },
    changeMargin () {
      if (!this.saveOnBlur) {
        return;
      }
      this.save();
    }
  }
};
</script>
